import { render, staticRenderFns } from "./mobile-question-detail.vue?vue&type=template&id=9dfbf3c8&scoped=true&"
import script from "./mobile-question-detail.vue?vue&type=script&lang=js&"
export * from "./mobile-question-detail.vue?vue&type=script&lang=js&"
import style0 from "./mobile-question-detail.vue?vue&type=style&index=0&id=9dfbf3c8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dfbf3c8",
  null
  
)

export default component.exports